// extracted by mini-css-extract-plugin
export var container = "_16-0";
export var disabled = "_16-4";
export var fullWidth = "_16-3";
export var lined = "_16-1";
export var selected = "_16-5";
export var tab = "_16-2";